/* eslint-disable no-param-reassign */
const motionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
const STEP_DELAY_MS = 400;
const MIN_VISIBLE_RATIO = 0.4;

function getVisibleRatioWithinViewport(entry) {
  const { boundingClientRect, rootBounds } = entry;
  const viewportTop = rootBounds ? rootBounds.top : 0;
  const viewportBottom = rootBounds ? rootBounds.bottom : window.innerHeight;
  const visibleTop = Math.max(boundingClientRect.top, viewportTop);
  const visibleBottom = Math.min(boundingClientRect.bottom, viewportBottom);
  const visibleHeight = Math.max(0, visibleBottom - visibleTop);
  const viewportHeight = viewportBottom - viewportTop;

  if (viewportHeight <= 0) {
    return 0;
  }

  return visibleHeight / viewportHeight;
}

function isBlockReadyToAnimate(entry) {
  const { boundingClientRect, rootBounds, intersectionRatio } = entry;

  if (!entry.isIntersecting) {
    return false;
  }

  const viewportTop = rootBounds ? rootBounds.top : 0;
  const viewportBottom = rootBounds ? rootBounds.bottom : window.innerHeight;
  const blockCenter = boundingClientRect.top + (boundingClientRect.height / 2);
  const centerIsVisible = blockCenter >= viewportTop && blockCenter <= viewportBottom;
  const viewportFillRatio = getVisibleRatioWithinViewport(entry);

  if (boundingClientRect.height > viewportBottom - viewportTop) {
    return viewportFillRatio >= MIN_VISIBLE_RATIO || centerIsVisible;
  }

  return intersectionRatio >= MIN_VISIBLE_RATIO || centerIsVisible;
}

function runAnimation(rootEl) {
  if (rootEl.dataset.animationStarted === 'true') {
    return;
  }

  rootEl.dataset.animationStarted = 'true';

  if (motionMQ.matches) {
    rootEl.dataset.animation = 'step-2';
    return;
  }

  rootEl.dataset.animation = 'pre';

  window.setTimeout(() => {
    rootEl.dataset.animation = 'step-1';

    window.setTimeout(() => {
      rootEl.dataset.animation = 'step-2';
    }, STEP_DELAY_MS);
  }, STEP_DELAY_MS);
}

function initTextAnimation(rootEl) {
  if (!rootEl || rootEl.dataset.animationStarted === 'true') {
    return;
  }

  if (motionMQ.matches) {
    rootEl.dataset.animation = 'step-2';
    rootEl.dataset.animationStarted = 'true';
    return;
  }

  rootEl.dataset.animation = 'pre';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!isBlockReadyToAnimate(entry)) {
        return;
      }

      observer.unobserve(rootEl);
      runAnimation(rootEl);
    });
  }, {
    threshold: [0, 0.25, MIN_VISIBLE_RATIO, 0.75, 1],
    rootMargin: '0px',
  });

  observer.observe(rootEl);
}

function initAll() {
  document.querySelectorAll('.text-animation').forEach((rootEl) => initTextAnimation(rootEl));
}

function initTextAnimationBlock() {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-text-animation', initAll);
  }

  initAll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTextAnimationBlock);
} else {
  initTextAnimationBlock();
}
